
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

import heroImg from '../../../assets/noidaAirportPlot/mainfeed.jpeg'
import logo from '../../../assets/noidaAirportPlot/logo.jpeg'


import ameneties1 from '../../../assets/noidaAirportPlot/ameneties-1.jpg'
import ameneties2 from '../../../assets/noidaAirportPlot/ameneties-2.webp'
import ameneties3 from '../../../assets/noidaAirportPlot/ameneties-3.jpg'
import ameneties4 from '../../../assets/noidaAirportPlot/ameneties-4.webp'
import ameneties5 from '../../../assets/noidaAirportPlot/ameneties-5.jpg'
import ameneties6 from '../../../assets/noidaAirportPlot/ameneties-6.webp'
import ameneties7 from '../../../assets/noidaAirportPlot/ameneties-7.jpg'
import ameneties8 from '../../../assets/noidaAirportPlot/ameneties-8.webp'
import ameneties9 from '../../../assets/noidaAirportPlot/ameneties-9.jpg'
import ameneties10 from '../../../assets/noidaAirportPlot/ameneties-10.jpg'



import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';

const cities = ["Noida Airport", "Noida Filmcity", "Noida Rapid Metro", "Noida IT Hubs", "Noida Toycity"];

const NoidaAirportPlots = () => {
    const [cityIndex, setCityIndex] = useState(0);
    const location = useLocation();
    const [openImgModal, setOpenImgModal] = useState(false);
    const [selectedImgIndex, setSelectedImgIndex] = useState(null);

    const ameneties = [
        { id: 0, img: ameneties1, title: "Beautiful Landscaping" },
        { id: 1, img: ameneties2, title: "CCTV Surveillance" },
        { id: 2, img: ameneties3, title: "High Street Commerical" },
        { id: 3, img: ameneties4, title: "Concrete Roads" },
        { id: 4, img: ameneties5, title: "Gated Community" },
        { id: 5, img: ameneties6, title: "Jewar International Airport" },
        { id: 6, img: ameneties7, title: "Jewar Film City" },
        { id: 7, img: ameneties8, title: "Rapid Metro to Airport" },
        { id: 8, img: ameneties9, title: "3 National Expressway" },
        { id: 9, img: ameneties10, title: "Next Corporates Hub" }
    ]

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCityIndex((prevIndex) => (prevIndex + 1) % cities.length);
        }, 2000)
        return () => clearInterval(interval);
    }, []);

    const handleOpenModal = (index) => {
        setSelectedImgIndex(index);
        setOpenImgModal(true);
    }

    return (
        <div className="w-full min-h-screen bg-gray-100 mt-5">
            <div className="relative w-full min-h-screen">
                <section className="relative h-screen w-full">
                    <img
                        src={heroImg}
                        alt="Hero"
                        className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                    <div className="relative z-10 flex flex-col items-start justify-center h-full text-left text-white px-4 sm:px-10 md:px-20">
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold">
                            {/* <br /> Estate Investments in{" "} */}
                            Invest In Future , <br />
                            Invest Near {" "}
                            <span className="text-green-400 transition-all duration-500">
                                {cities[cityIndex]}
                            </span>
                        </h1>
                    </div>
                </section>
            </div>
            
            <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
                <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[300px]">
                    <img src={logo} alt="logo" className="w-full h-full object-contain rounded-lg" />
                </div>
            </div>

            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div className="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                The area around Noida International Airport in Jewar City has become a hotspot for plotted
                                developments, offering excellent opportunities for residential, commercial, and investment
                                purposes. Here's a detailed description of what makes these plots so appealing:
                            </p>
                            <h2 className="text-2xl md:text-3xl font-bold my-2">Key Features:</h2>
                            <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Location:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        Situated near the upcoming Noida International Airport (Jewar Airport), these plots
                                        enjoy a prime location with excellent connectivity to Delhi, Noida, Greater Noida, and Agra via the
                                        Yamuna Expressway. The airport is expected to be one of the largest in India, making the surrounding
                                        area a major hub for development.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Plot Sizes:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        A variety of plot sizes are available, ranging from smaller residential plots (100-200
                                        sq. yards) to larger commercial and industrial plots (500-1000 sq. yards), catering to diverse needs.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Infrastructure:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The region is witnessing rapid infrastructure development, including metro
                                        connectivity, expressways, and the Delhi-Mumbai Industrial Corridor. These developments enhance
                                        the area's accessibility and investment potential.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Amenities:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        Many plotted developments offer modern amenities such as gated communities,
                                        landscaped parks, jogging tracks, community centers, and 24/7 security, ensuring a comfortable and
                                        secure living environment.
                                    </p>
                                </div>
                            </section>


                            <h2 className="text-2xl md:text-3xl font-bold my-4">Highlights :</h2>
                            <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Investment Potential:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The proximity to Noida International Airport has significantly boosted
                                        the real estate market in Jewar City. Property values are expected to appreciate rapidly, making it an
                                        attractive investment destination.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Sustainability:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        Developers are incorporating eco-friendly practices, such as rainwater
                                        harvesting and green spaces, to create sustainable living environments.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Commercial Opportunities :</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The area is ideal for setting up businesses, retail outlets, and
                                        hospitality ventures, given the expected influx of travelers and professionals once the airport
                                        becomes operational.
                                    </p>
                                </div>
                            </section>

                            <h2 className="text-2xl md:text-3xl font-bold my-4">Why Choose Plots Near Noida International Airport? :</h2>
                            <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Strategic Location:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The plots are located in a region poised for exponential growth, with
                                        excellent connectivity and proximity to major cities and industrial hubs.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Flexibility:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        Buyers have the freedom to design and build their dream homes or commercial
                                        spaces according to their preferences.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Developer Reputation :</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        Many reputed developers are offering plotted developments in the
                                        area, ensuring quality and timely delivery.
                                    </p>
                                </div>
                            </section>
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                This region is a promising destination for those looking to invest in real estate or build their dream
                                property. With the upcoming airport and robust infrastructure, the area around Jewar City is set to
                                become a thriving hub for residential and commercial activities.
                            </p>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            <div className="max-w-7xl mx-auto p-4">
                <h2 className="text-2xl font-semibold text-gray-800 my-4">
                    Projects Highlights
                </h2>
                {openImgModal && (
                    <ImageModal
                        images={ameneties.map((item) => item.img)}
                        openImg={openImgModal}
                        selectedImgIndex={selectedImgIndex}
                        onClose={() => setOpenImgModal(false)}
                    />
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {ameneties.map((data, index) => (
                        <div key={index}
                            onClick={() => handleOpenModal(index)}
                            className="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden bg-white">
                            <div className="relative">
                                <img
                                    src={data.img}
                                    alt={data.title}
                                    className="w-full h-56 object-cover transition-transform duration-300 transform hover:scale-105"
                                />
                            </div>
                            <div className="px-5 py-3">
                                <h3 className="text-gray-700 font-semibold">{data.title}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
export default NoidaAirportPlots